import { useEffect, useState } from "react"
import Loader from "../../../components/ui/Loader/Loader";
import { useSelector } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import { useParams, Link } from "react-router-dom";
import { DisplayListPagination } from "../../../components/TapUi";
import TapIcon from "../../../services/TapIcon";
import DateService from "../../../services/DateService";
import { toast } from "react-toastify";
import swal from 'sweetalert';

function AssetComplianceDocList() {


    const { id }                    =   useParams();   
    const docsListUrl               =   `${IAM_API_BASE_URL_2}/asset_compliance/document/${id}`;
    const docsDeleteUrl             =   `${IAM_API_BASE_URL_2}/asset_compliance/document`;

    const access_token              =   useSelector(state => state.auth.access_token);
    const permissions               =   useSelector(state => state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : []);

    const [loading, setLoading]     =   useState(false);
    const [data, setData]           =   useState([]);
    const [listingMeta, setListingMeta] =   useState(null);

    useEffect(() => {
        getDocsList();
    }, [])

    const  getDocsList  =   async (page = 1)  =>  {
        setLoading(pre => !pre);
        const res   =   await HttpAPICall.withAthorization("GET", docsListUrl, access_token, {page}, {});
        const respData  =   res.data;
        setData(respData.data)
        setListingMeta({
            from: respData.from,
            to: respData.to,
            total: respData.total,
            last_page: respData.last_page,
            per_page: respData.per_page,
            current_page: respData.current_page
        });
        setLoading(pre => !pre);
    }
    const deleteDocument    =   (doc_id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', docsDeleteUrl + '/' + doc_id, access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    getDocsList();
                }).then(() => { });
            }
        });

    }

  return (
    <>
            <div className="tab_content_wrapper mt-2">
                <span className="content_heading">Asset Compliance Documents</span>
            </div>
            
            <table className="table table-bordered mt-3">
                <thead className="table-secondary">
                    <tr>
                        <td style={{ width: "5%" }}>S.No</td>
                        <td style={{ width: "20%" }}>Compliance Name</td>
                        <td style={{ width: "20%" }}>Document Name</td>
                        <td style={{ width: "10%" }}>Document Number</td>
                        <td style={{ width: "10%" }}>Upload By</td>
                        <td style={{ width: "10%" }}>Upload Date</td>
                        <td style={{ width: "10%" }} className="text-center">Action</td>
                        {/* <th style={{ width: "20%" }}>View/Download</th> */}
                    </tr>
                </thead>
                <tbody>
                    {
                        loading 
                        ? <tr><td className='text-center' colSpan={7}><Loader /></td></tr>
                        :   
                        data.length > 0 
                        ?
                        data.map((d, index) => (
                            <tr key={d.id}>
                                <td className="text-center">{listingMeta ? listingMeta?.from + index : index}</td>
                                <td>{d.compliance_name}</td>
                                <td>{d.name}</td>
                                <td className="text-end">{d.number}</td>
                                <td>{d.created_by ? d.created_by.full_name : ''}</td>
                                <td>{DateService.dateFormat(d.created_at)}</td>
                                <td className="text-center">
                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                        <TapIcon.FontAwesomeIcon icon={TapIcon.faEllipsisV} />
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <Link to={{ pathname: d.path }} target="_blank"
                                                className={`dropdown-item ${permissions.includes('iam-asset-doc-view') ? '' : 'disabled-link'}`}
                                                title={permissions.includes('iam-asset-doc-view') ? '' : 'You do not have permission to perform this action'}
                                                style={{ "pointerEvents": "all" }}>
                                                View
                                            </Link>
                                        </li>
                                        <li>
                                            <Link target='_blank' to={{ pathname: d.download_link }} className={`dropdown-item ${permissions.includes('iam-asset-doc-download') ? '' : 'disabled-link'}`} role="button" title={permissions.includes('iam-asset-doc-download') ? '' : 'You do not have permission to perform this action'}>Download</Link>
                                        </li>
                                        <li>
                                            <Link className={`dropdown-item ${permissions.includes('iam-asset-doc-delete') ? '' : 'disabled-link'}`} role="button"  onClick={() => { permissions.includes('iam-asset-doc-delete') && deleteDocument(d.id) }} title={permissions.includes('iam-asset-doc-delete') ? '' : 'You do not have permission to perform this action'}>Delete</Link>
                                        </li>

                                        {/* 
                                         <TapIcon.FontAwesomeIcon icon={TapIcon.faEye} />
                                         <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                                         <TapIcon.FontAwesomeIcon icon={TapIcon.faTrashAlt} className="asset_link" /> 
                                        */}
                                    </ul>
                                </td>
                            </tr>
                        ))
                        : <tr><td className='text-center' colSpan={7}>No Record Found</td></tr>
                    }
                </tbody>
            </table>
            <DisplayListPagination meta={listingMeta} onPageChange={(e) => getDocsList(e.selected + 1)}/>
        </>
  )
}

export default AssetComplianceDocList